const data = {};
export const Storage = {
  async set(key, value) {
    data[key] = value;
  },
  get(key, defaultValue = undefined) {
    return data[key] || defaultValue;
  },
};
